import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Card, CardBody } from '@pancakeswap/uikit'
import { cronosTokens } from '@pancakeswap/tokens'
import { LockV2Config, LockV2Data } from '../../../types'
import LockCardHeader from '../LockCardHeader'
import { getStatus } from '../../../hooks/helpers'
import LockTimer from '../../LockTimer'
import LockCardDetails from './LockCardDetails'
import LockCardAction from './LockCardAction'

const StyledLockCard = styled(Card)`
  background-repeat: no-repeat;
  background-size: contain;
  margin-left: auto;
  margin-right: auto;
  max-width: 437px;
  width: 100%;
`

const LockV2Card: React.FC<{
  data: LockV2Data;
  config: LockV2Config;
  onUnlocked: () => void
}> = ({ data, config, onUnlocked }) => {
  const candyToken = cronosTokens.candy
  const { duration, lockAt } = data

  const [state, setState] = useState({
    status: null,
    currentTime: Math.floor(Date.now() / 1000),
  })

  useEffect(() => {
    const interval = setInterval(async () => {
      const currentTime = Math.floor(Date.now() / 1000)
      const status = getStatus(currentTime, lockAt, duration)
      setState({ status, currentTime })
    }, 1000)
    return () => clearInterval(interval)
  }, [lockAt, duration])

  return (
    <StyledLockCard>
      <CardBody style={{ padding: '24px 16px' }}>
        <LockCardHeader name={candyToken.name} address={candyToken.address} />
        <LockTimer
          currentTime={state.currentTime}
          duration={duration}
          lockAt={lockAt}
          unlocked={false} />
        <LockCardDetails
          config={config}
          data={data}
          epochTime={state.currentTime} />
        <LockCardAction data={data} />
      </CardBody>
    </StyledLockCard>
  )
}

export default LockV2Card
